import { NextYearsDDL } from "../constants/constant";
import { AllMonths } from "../data/dropDownData";

export function getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export function convertLocalToUTC(localDateTime: any) {
    return new Date(localDateTime).toISOString();
}
export function convertUTCToLocal(utcDateTime: any) {
    return new Date(utcDateTime);
}
export function formatDateyyyyMMdd(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    if (delimiter) {
        return `${year}${delimiter}${month}${delimiter}${date}`;
    }
    else {
        return `${year}${month}${date}`;
    }
}
export function formatDateyyyyMM(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let month, year;
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    month = month.toString().padStart(2, "0");
    if (delimiter) {
        return `${year}${delimiter}${month}`;
    }
    else {
        return `${year}${month}`;
    }
}
export function formatDateyyyyMMddTHHMM(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year, hh, mm;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    hh = inputDate.getHours().toString().padStart(2, "0");
    mm = inputDate.getMinutes().toString().padStart(2, "0");
    if (delimiter) {
        return new Date(`${year}${delimiter}${month}${delimiter}${date}T${hh}:${mm}`);
    }
    else {
        return new Date(`${year}${month}${date}T${hh}:${mm}`);
    }
}
export function formatDate(inputDate: any, delimeter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    if (delimeter) {
        return `${date}${delimeter}${month}${delimeter}${year}`;
    }
    else {
        return `${date}${month}${year}`;
    }
}
export function getDate(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let date;
    date = inputDate.getDate();
    //date = date.toString().padStart(2, "0");
    return date;
}
export function getMonth(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let month;
    month = inputDate.getMonth() + 1;
    //month = month.toString().padStart(2, "0");
    return month;
}
export function getYear(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let year;
    year = inputDate.getFullYear();
    return year;
}

export function formatDateTime(date: any) {
    const newDate = new Date(date);
    let str =
        ("00" + (newDate.getDate())).slice(-2) +
        "/" +
        ("00" + (newDate.getMonth() + 1)).slice(-2) +
        "/" +
        newDate.getFullYear() +
        " " +
        ("00" + newDate.getHours()).slice(-2) +
        ":" +
        ("00" + newDate.getMinutes()).slice(-2) +
        ":" +
        ("00" + newDate.getSeconds()).slice(-2);
    return str;
}
export function formatShortMonthYear(inputDate: any) {
    return new Date(inputDate).toLocaleDateString('en-IN', { month: "short", year: "numeric" })
}
export function formatshortDayMonthYear(date: any) {
    return date ? new Date(date).toLocaleDateString('en-IN', {
        day: "numeric",
        month: "short",
        year: "numeric",
    })
        : "";
    //22 June 2025
}
export function getSelectLabel(options: any[], value: any) {
    if (options.length > 0) {
        const selectedValues = Array.from(options)
            .filter((option: any) => option.value == value)
            .map((option: any) => option.label);
        return selectedValues || value;
    }
    else
        return value;
}
export function getYearsDDL(yearsIncrement: number, year: number = 0) {
    const currentYear = new Date().getFullYear();
    let nextYears = Array.from({ length: yearsIncrement }, (_, i) => currentYear + i)
        .map((year: number, index) => ({ label: year, value: year }))
    if (year != 0 && year < currentYear) {
        nextYears = [{ label: year, value: year }, ...nextYears];
        //nextYears.push({ label: year, value: year });
    }
    return nextYears;
}
export function getmonthsDDL(years: number, month: number = 0) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); // 0-based index for months 
    let filteredMonths: any = [];
    if (currentYear == years) {
        filteredMonths = AllMonths.slice(currentMonth);
    }
    else if (currentYear < years) {
        filteredMonths = AllMonths;
    }
    if (month != 0) {
        const selectedValues = Array.from(AllMonths).filter((option: any) => option.value == month);

        if (!(Array.from(filteredMonths).filter((option: any) => option.value == month).length > 0))
            filteredMonths = [selectedValues[0], ...filteredMonths];
    }
    return filteredMonths;
}
export const encodeParam = (param: any) => {
    return btoa(param).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
export const decodeParam = (param: any) => {
    try {
        param = param.padEnd(param.length + (4 - param.length % 4) % 4, '=');
        return atob(param.replace(/-/g, '+').replace(/_/g, '/'));
    } catch (e) {
        return "";
    }
};
export const convertTextToSlugify = (str: any) => str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');
export const convertSlugifyToText = (str: any) => str ? str.replace(/-/g, ' ').replace(/\b\w/g, (l: any) => l.toUpperCase()) : null;

export function formatText(text: any, splitDelimeter: any, outputDelimeter: any) {
    const formattedText = text
        .split(splitDelimeter)
        .map((part: any, index: any) =>
            part.trim().charAt(0).toUpperCase() + part.trim().slice(1) // Capitalize only first letter
        )
        .join(` ${outputDelimeter} `);

    return formattedText;
}
export function getShortWeekDay(year: any, month: any, date: any) {
    const tempDate = new Date(year + "-" + month + "-" + date);
    return tempDate.toLocaleString('default', { weekday: 'short' })
}
export function getDateMonthRange() {
    const nextYears = NextYearsDDL;
    const today = new Date();

    const minDate = today;

    const maxDateObj = new Date(today);
    maxDateObj.setFullYear(today.getFullYear() + nextYears);
    const maxDate = maxDateObj;

    const minMonth = new Date(today + "-01");
    const maxMonth = new Date(maxDateObj + "-01");

    return {
        minDate,
        maxDate,
        minMonth,
        maxMonth
    };
}
export const getDiscountedPrice = (discountType: any, cost: any, discount: any) => {
    let amount = cost;
    if (amount > 0) {
        if (discountType == "fixed")
            amount = cost - discount;
        else if (discountType == "percent")
            amount = cost - (cost * discount / 100)
    }
    return amount;
}